module.exports = "/img/_/_/_/assets/images//navigation_drawer.png?7029931eee9b6b6418720d0e90e54ae8";